import React from "react";
import "../assets/css/Blog.css";

const blogs = [
  {
    id: 1,
    title: "Building Modern React Applications",
    date: "July 20, 2026",
    category: "React",
    description:
      "Learn how to build scalable and reusable React applications using hooks, routing, state management, and best practices."
  },
  {
    id: 2,
    title: "JavaScript Interview Preparation Guide",
    date: "July 15, 2026",
    category: "JavaScript",
    description:
      "A collection of the most frequently asked JavaScript interview questions with clear explanations and practical examples."
  },
  {
    id: 3,
    title: "My Journey from Electronics to Software Engineering",
    date: "July 10, 2026",
    category: "Career",
    description:
      "How I transitioned from Electronics Engineering to Full Stack Development, the challenges I faced, and lessons I learned."
  }
];

export default function Blog() {
  return (
    <article className="blog active">

      <header>
        <h2 className="h2 article-title">Blog</h2>
        <p className="blog-subtitle">
          Articles, tutorials, and personal experiences about software
          development, career growth, and technology.br
          <br/>
          (We're currently working on creating high-quality articles and tutorials. Stay tuned—exciting content will be available very soon!)
          
        </p>
      </header>

      <section className="blog-grid">
        {blogs.map((blog) => (
          <div className="blog-card" key={blog.id}>
            <span className="blog-category">{blog.category}</span>

            <h3>{blog.title}</h3>

            <small>{blog.date}</small>

            <p>{blog.description}</p>

            <button className="read-btn">
              Read More →
            </button>
          </div>
        ))}
      </section>

    </article>
  );
}